// TODO this will be deprecated after https://github.com/catalyticlabs/pushbot-api/pull/6643

import api from '../../store/config/api';
import { CREDENTIAL_LIST as SCHEMA } from '../../schemas';

export const [
  GET_CREDENTIALS,
  GET_CREDENTIALS_REQUEST,
  GET_CREDENTIALS_SUCCESS,
  GET_CREDENTIALS_FAILURE
] = api.buildTypes('GET_CREDENTIALS');

export function getCredentials({ teamName }) {
  return {
    type: GET_CREDENTIALS,
    payload: {
      url: `/teams/${teamName}/credentials`,
      schema: SCHEMA
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/credentials.js